function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.0002 2.00008C4.68649 2.00008 2.0002 4.68637 2.0002 8.00008C2.0002 11.3138 4.68649 14.0001 8.0002 14.0001C11.3139 14.0001 14.0002 11.3138 14.0002 8.00008C14.0002 4.68637 11.3139 2.00008 8.0002 2.00008ZM0.66687 8.00008C0.66687 3.94999 3.95011 0.666748 8.0002 0.666748C12.0503 0.666748 15.3335 3.94999 15.3335 8.00008C15.3335 12.0502 12.0503 15.3334 8.0002 15.3334C3.95011 15.3334 0.66687 12.0502 0.66687 8.00008Z",
  fill: "#233780"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.4712 5.52851C10.7316 5.78886 10.7316 6.21097 10.4712 6.47132L6.4712 10.4713C6.21085 10.7317 5.78874 10.7317 5.52839 10.4713C5.26804 10.211 5.26804 9.78886 5.52839 9.52851L9.52839 5.52851C9.78874 5.26816 10.2109 5.26816 10.4712 5.52851Z",
  fill: "#233780"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.52839 5.52851C5.78874 5.26816 6.21085 5.26816 6.4712 5.52851L10.4712 9.52851C10.7316 9.78886 10.7316 10.211 10.4712 10.4713C10.2109 10.7317 9.78874 10.7317 9.52839 10.4713L5.52839 6.47132C5.26804 6.21097 5.26804 5.78886 5.52839 5.52851Z",
  fill: "#233780"
});

var SvgCircleCross = function SvgCircleCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circleCross.ddaa27cd.svg";
export { ForwardRef as ReactComponent };